import React from 'react';
import propTypes from './propTypes';

const EquipmentProductivity = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22.3264 11C22.7583 10.0907 23 9.0736 23 8C23 4.13401 19.866 1 16 1C12.134 1 9 4.13401 9 8C9 9.0736 9.24169 10.0907 9.67363 11H22.3264Z" fill="white" />
    <path fillRule="evenodd" clipRule="evenodd" d="M7.70095 6.15428L7 3H5L7 12L6 16H4V14.5C4 13.6714 3.32837 13 2.5 13C1.67163 13 1 13.6714 1 14.5V19.5C1 20.3286 1.67163 21 2.5 21C3.32837 21 4 20.3286 4 19.5V18H6V23L8 21V18H10V23L12 21V18H14V23L16 21V18H18V19.5C18 20.3286 18.6716 21 19.5 21C20.3284 21 21 20.3286 21 19.5V14.5C21 13.6714 20.3284 13 19.5 13C18.6716 13 18 13.6714 18 14.5V16H16L15.125 12.5H8.72555L8.31874 11.6436C7.79328 10.5375 7.5 9.30091 7.5 8C7.5 7.36616 7.56938 6.74853 7.70095 6.15428ZM8 16L8.5 14H13.5L14 16H8Z" fill="currentColor" />
    <path d="M21.1639 3.27406C22.3042 4.51935 23 6.17842 23 8C23 9.0736 22.7583 10.0907 22.3264 11H9.67363C9.24169 10.0907 9 9.0736 9 8C9 4.13401 12.134 1 16 1C16.845 1 17.655 1.14973 18.405 1.4241L15.7277 3.00729C13.0929 3.14868 11 5.32992 11 8C11 8.3434 11.0343 8.67767 11.0996 9H20.9004C20.9657 8.67767 21 8.3434 21 8C21 6.92176 20.6587 5.92323 20.0782 5.10655L21.1639 3.27406Z" fill="currentColor" />
    <path d="M17.2026 7.01653L20.0655 2.1842L15.1966 5.06338C15.0545 5.14387 14.8918 5.23657 14.7622 5.36618C14.1765 5.95196 14.1765 6.90171 14.7622 7.4875C15.348 8.07328 16.2978 8.07328 16.8836 7.4875C17.0232 7.3479 17.1088 7.17592 17.2026 7.01653Z" fill="currentColor" />
  </svg>
);

EquipmentProductivity.propTypes = propTypes;

export default EquipmentProductivity;
